// In-page anchor to the embedded booking portal iframe (see BookingPortal.jsx)
export const BOOK_URL = "#book-portal";

export const ASSETS = {
  valveHero: "/assets/valve-hero.png",
  valveAngle: "/assets/valve-angle.png",
  phynUnit: "/assets/phyn-unit.webp",
  deviceVideo: "/assets/LDU.mp4",
  logoHorizontal: "/assets/logo-horizontal.png",
  logoStacked: "/assets/logo-stacked.png",
  logoStackedBlack: "/assets/logo-stacked-black.png",
  tpecoLogo: "/assets/tpeco-logo.png",
  tpecoLogoWhite: "/assets/tpeco-logo-white.png",
  tpecoWithLicense: "/assets/tpeco-with-license.png",
  caromaWhite: "/assets/caroma-white.png",
  team: "/assets/team.webp",
  // Ordered turntable frames (rotate-into-view: turned away -> settles front)
  valveFrames: [
    "/assets/turntable/frame_11.png",
    "/assets/turntable/frame_03.png",
    "/assets/turntable/frame_00.png",
    "/assets/turntable/frame_09.png",
    "/assets/turntable/frame_06.png",
    "/assets/turntable/frame_04.png",
    "/assets/turntable/frame_05.png",
    "/assets/turntable/frame_07.png",
    "/assets/turntable/frame_02.png",
    "/assets/turntable/frame_01.png",
  ],
  water: "https://images.unsplash.com/photo-1776042675777-3802f02f816e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxjaW5lbWF0aWMlMjB3YXRlciUyMHNwbGFzaCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4NTMxMDk3NXww&ixlib=rb-4.1.0&q=85",
  home: "https://images.unsplash.com/photo-1765767056681-9583b29007cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtb2Rlcm4lMjBob21lJTIwZGFyayUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODMxMDIxNzB8MA&ixlib=rb-4.1.0&q=85",
  aiTexture: "https://images.unsplash.com/photo-1617397493721-7f735bbbfab8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxzbWFydCUyMGhvbWUlMjBkZXZpY2UlMjBkYXJrJTIwYmFja2dyb3VuZCUyMGJsdWUlMjBsaWdodHxlbnwwfHx8fDE3ODIxNjc2ODh8MA&ixlib=rb-4.1.0&q=85",
};
